'use strict';

var SectionTypes = require('../constants/SectionTypes'),
    isEmptyishHTML = require('./isEmptyishHTML'),
    { isEmpty, isUndefined } = require('underscore');

function isSectionEmpty(section, ignoreCover) {
  switch (section.type) {
  case SectionTypes.COVER:
    return !ignoreCover && isEmpty(section.title) && isEmpty(section.subtitle) && isEmpty(section.background);
  case SectionTypes.TEXT:
    return isEmpty(section.text) || isEmptyishHTML(section.text);
  case SectionTypes.GALLERY:
    return section.images.length === 0;
  case SectionTypes.POSTER:
    return isEmpty(section.background);
  case SectionTypes.MEDIA:
    return isEmpty(section.url) || isUndefined(section.background);
  }
}

module.exports = isSectionEmpty;


/** WEBPACK FOOTER **
 ** ./utils/isSectionEmpty.js
 **/